export const OHIF_LOCALHOST = 'http://localhost:3000/';
export const SCORING_FORMS_LOCALHOST = 'http://localhost:3030/';

export const DICOM_VIEWER_VERSION_OPTIONS = [
  { label: 'v3.9.0', value: 'V3_9_0' },
  { label: 'v3.11.0', value: 'V3_11_0' },
];
